import JSON5 from 'process-js-objects'
import initI18n from 'www/utils/executors/initI18n'
import isJSON5 from 'www/utils/is/isJSON5'
import type { OpenEventDetail } from 'www/vue_components/common/AppointmentRestrictions/types'

(async () => {
  const mountElement = document.querySelector('.vue-appointment-restrictions-mount')

  if (!mountElement) {
    return
  }

  await initI18n({ bundle: 'vue_components/common/AppointmentRestrictions' })

  const { default: Vue } = await import(/* webpackMode: "eager" */'www/vue_components')
  const { default: vuetify } = await import(/* webpackMode: "eager" */'www/modules/vuetify-plugin')
  const { default: AppointmentRestrictions } = await import(/* webpackMode: "eager" */'www/vue_components/common/AppointmentRestrictions/AppointmentRestrictions.vue')

  const appointmentRestrictionsRoot = new Vue({
    vuetify,
    el: mountElement,
    name: 'AppointmentRestrictionsRoot',
    render: h => h(AppointmentRestrictions, { ref: 'appointmentRestrictionsRef' }),
  })

  document.addEventListener('click', event => {
    if (!event.target) {
      return
    }

    const target = (event.target as HTMLElement).closest('.js-appointment-restrictions-btn-open')

    if (!target) {
      return
    }

    const detail = target.getAttribute('data-appointment-restrictions')

    if (appointmentRestrictionsRoot.$refs.appointmentRestrictionsRef && detail && isJSON5(detail)) {
      // @ts-ignore
      appointmentRestrictionsRoot.$refs.appointmentRestrictionsRef.open(JSON5.parse(detail) as OpenEventDetail)
    }
  })
})()
